import { render, staticRenderFns } from "./handleOld.vue?vue&type=template&id=d7174514&scoped=true&"
import script from "./handleOld.vue?vue&type=script&lang=js&"
export * from "./handleOld.vue?vue&type=script&lang=js&"
import style0 from "./handleOld.vue?vue&type=style&index=0&id=d7174514&scoped=true&lang=less&"
import style1 from "./handleOld.vue?vue&type=style&index=1&id=d7174514&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7174514",
  null
  
)

export default component.exports